export default __webpack_public_path__ + "2bdb942896e9579edf3a715decdddfd1.pdf";